import { Col, ColType, Crud, CrudApi } from "../../comp/crud";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import { TextCell } from "../../comp/cell";
import {
  ApiClient,
  displayTodoStatus,
  getTodoStatusOpt,
} from "../../api/ApiClient";
import { useContext, useEffect, useState } from "react";
import { Form, Modal, Typography, SideSheet, Button, Tag, Toast } from "@douyinfe/semi-ui";
import { IconBell, IconMail } from "@douyinfe/semi-icons";


let apiClient = ApiClient.getDefault();
const { Text } = Typography;

export interface TodoCrudProps {
  visible: boolean
  onCancel?: () => void

}

export function TodoCrud(props: TodoCrudProps) {

  const [app, setApp] = useState(undefined as undefined | any);
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const role = localStorage.getItem("role");
  const [showTodo, setShowTodo] = useState(false);
  const [todoFormApi, setTodoFormApi] = useState<FormApi>();
  const [savingTodo, setSavingTodo] = useState(false);
  const [leadId, setLeadId] = useState<number>();
  const [todoId, setTodoId] = useState<number>();

  useEffect(() => {

  }, []);

  let cols: Col[] = [
    {
      name: "发起人",
      key: "createdByName",
      width: 80,
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "顾问",
      key: "userName",
      width: 80,
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "客户",
      key: "leadName",
      width: 90,
      showInFilter: true,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Button
            theme="borderless"
            type="tertiary"
            onClick={() => detailAction(record.leadId)}
          >
            {value}
          </Button>
        );

      },
    },


    {
      name: "状态",
      key: "done",
      width: 80,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: (row) => Promise.resolve(getTodoStatusOpt()),
      render: (value, index) => {
        if (value == "A_UNDO") {
          return (
            <Tag color="red" key={value} size='large'
              shape='circle'
              type='solid'> {displayTodoStatus(value)} </Tag>
          );

        } else {
          return (
            <Tag color="green" key={value} size='large'
              shape='circle'
              type='solid'> {displayTodoStatus(value)} </Tag>
          );
        }
      },
    },
    {
      name: "发起时间",
      key: "createdAt",
      width: 160,
      type: ColType.DATETIME,
      defaultSortOrder: "descend",
    },
    {
      name: "提醒内容",
      key: "content",
      type: ColType.STRING,
      render: (a, b, c) => <TextCell text={a} width={250} />,
    },
    {
      name: "城市",
      key: "leadCity",
      width: 60,
      hideInCreate: true,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },

  ];

  //打开详情
  const detailAction = (leadId: number) => {
    const w = window.open("about:blank");
    if (w != null) {
      const data = {
        id: leadId,
        ids: [],
      };
      w.location.href =
        "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  return (
    <SideSheet style={{ width: '1200px' }} title="提醒事项" visible={props.visible} onCancel={props.onCancel} size='large'>
      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
        }}
        canUpdate={false}
        canCreate={false}
        select={false}
        name="提醒信息"
        entityKey="todos"
        pageSize={50}
        getRowActions={(a) => {
          // let detailAction = {
          //   name: "详情",
          //   action: () => {
          //     const w = window.open("about:blank");
          //     if (w != null) {
          //       const data = {
          //         id: a.leadId,
          //         ids: [],
          //       };
          //       w.location.href =
          //         "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
          //     }
          //   }
          // };
          let deleteAction = {
            name: "清除",
            action: () => {
              apiClient.deleteTodo(a.id);
              crudApi?.refresh();
            }
          };
          if (role == "sale") {
            return []
          } else {
            return [deleteAction]
          }


        }
        }
        cols={cols}
      />


    </SideSheet>
  );
}
